import * as React from 'react';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import { translateThis } from '../helpers/language.helper';

// import AppIcons from '../../assets/images/icons';
// import mail from '../../assets/images/icons/email.svg';



// import './ContactPopup.scss';
// import { Link } from 'react-router-dom';
// import { showSnackbar } from '../Notification/Snackbar';
// import { postQuery } from '../../services/api/enquires';


function VerificationForm(props) {
  const [open, setOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [formData, setFormData] = React.useState({});

  /**
 * sets the form data 
 * @param {string} name the name of the field
 * @param {string} value  the value of the field
 */
  const setFormValue = (name, value) => {
    const formDataAs = { ...formData };
    setFormData({ ...formDataAs, ...{ [name]: value } });
  }

  /**
   * Validates the form and returns true if valid
   * @returns boolean
   */
  const isValidForm = () => {
    let isValid = false;
    if (formData && formData.name &&
      formData.email &&
      formData.query) {
      isValid = true;
    }
    return isValid;
  }

  /**
   * On submit the form
   */
  const onSubmit = () => {
    if (isValidForm()) {
      // Submitting data to backend for registration
      setIsLoading(true);

      const formPostData = {
        name: formData.name,
        email: formData.email,
        phoneNumber: formData.phoneNumber,
        query: formData.query
      }

      // postQuery(formPostData).then((data) => {
      //   if (data.success) {
      //     setFormData(null);
      //     handleClose();
      //     showSnackbar().success(data.message)
      //   } else {
      //     showSnackbar().failure(data.message)

      //   }
      // }).finally(() => setIsLoading(false));
    }
  };


  return (
    <div className='contct-grid-wrp f-wrp'>
      <div className='contct-form-wrp f-wrp'>
        <h3>{translateThis("Secure access")}</h3>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className='each-TextField'>
              <h4>{translateThis("Your Code")}</h4>
              <TextField
                margin="dense"
                id="yourCode"
                name="Your Code"
                label=""
                placeholder={translateThis("Your Code")}
                type="text"
                fullWidth
                variant="standard"
                onChange={(e) => setFormValue('yourCode', e.target.value)}
              />
            </div>
          </div>
          
        </div>
        <div className='btn-wrp'>
          <Link to={'/'} className='plan-btn'>{translateThis('Forgot your verification code?')}</Link>
          <Button className='sqr-btn' disabled={!isValidForm()} onClick={onSubmit}>{isLoading ? <>{translateThis("Submitting...")}</> : <>{translateThis("Log in")}</>}</Button>
        </div>

        

      </div>
    </div>
  );
}

export default VerificationForm